import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DynamicPage from 'util/hoc/dynamic-page';
import Footer from 'library/sections/footer';
import RequiresAuth from 'util/hoc/requires-auth';
import AppHeader from 'components/header';
import { ShimmyValue } from 'library/components/shimmy';
import { resolve } from 'library/helpers/path-resolver';
import LockedApp from 'core/pages/locked';
import WithConfig from 'util/hoc/with-config';
import Honeybadger from '@honeybadger-io/js';
import IdleTimer from 'react-idle-timer';
import Logout from 'library/helpers/logout';
import { Clock } from 'library/icons';
import { Header5 } from 'library/components/text-elements';
import ConfirmationModal from 'apps/journey/components/modals/confirmation-modal';

const StyledConfirmWrapper = styled.div`
  max-width: 350px;
  p {
    font-size: 16px;
  }
  h5 {
    font-size: 22px;
  }
`;

const Personal = DynamicPage(async () => {
  return await import(
    /* webpackChunkName: "personal/app" */ 'apps/personal/app'
  );
});

export const AppNavigation = () => <span>{trans`Personal`}</span>;

const Main = ({ configuration, authentication }) => {
  const [timeoutState, setTimeoutState] = useState(false);

  Honeybadger.setContext({
    app: 'personal',
  });

  const handleOnIdle = () => {
    if (authentication.authorized) {
      setTimeoutState(true);
    }
  };

  const stayAlive = () => {
    setTimeoutState(false);
    window.location.reload();
  };

  return (
    <Fragment>
      <IdleTimer
        timeout={27 * 60 * 1000}
        crossTab={{ emitOnAllTabs: true }}
        onIdle={handleOnIdle}
        debounce={250}
      />
      <ShimmyValue namespace="main_navigation">
        <AppHeader show={true} />
      </ShimmyValue>
      {resolve(configuration, 'apps/personal/allowed', false) ? (
        <Fragment>
          <Personal />
          <Footer />
        </Fragment>
      ) : (
        <LockedApp />
      )}
      <ConfirmationModal
        cancelText="Logout"
        confirmText="Stay Logged In"
        toggleActive={() => Logout()}
        handleSubmit={() => stayAlive()}
        active={timeoutState}
        customIcon={<Clock width={24} height={24} />}
        customColor="#fec821"
      >
        <StyledConfirmWrapper>
          <Header5>Your session is about to expire.</Header5>
        </StyledConfirmWrapper>
      </ConfirmationModal>
    </Fragment>
  );
};

Main.propTypes = {
  configuration: PropTypes.object,
  authentication: PropTypes.object,
};

export default RequiresAuth(WithConfig(Main));
